import { PaymentSchedule } from "@redotech/redo-model/balance/balances";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const getOutboundBalance = {
  name: "getOutboundBalance" as const,
  input: zNull(),
  output: z.object({
    balance: z.string(),
    paymentSchedule: z.enum(PaymentSchedule),
  }),
};
